import React from "react";
import { cn } from "../../lib/utils";

/**
 * A small kg | lb switch (#191): both units visible, the current one filled,
 * so it reads as a choice without words saying "tap". Sized to sit beside a
 * number field or at the end of a row.
 */
const UnitToggle = ({ value = "kg", onChange, units = ["kg", "lb"], label = "Weight unit", className }) => (
  <span
    role="group"
    aria-label={label}
    className={cn("inline-flex shrink-0 rounded-full border border-border bg-muted/40 p-0.5 text-xs", className)}
  >
    {units.map((u) => (
      <button
        key={u}
        type="button"
        aria-pressed={value === u}
        onClick={(e) => {
          e.stopPropagation();
          if (value !== u) onChange(u);
        }}
        className={cn(
          "min-w-[2rem] rounded-full px-2 py-0.5 font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-ring",
          value === u ? "bg-background text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground",
        )}
      >
        {u}
      </button>
    ))}
  </span>
);

export default UnitToggle;
